import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../TheCrypt";
import {gsap} from "gsap";
import {TheCryptWinConfig, IBigWinLevel} from "../configs/TheCryptWinConfig";
import {TheCryptSymbol} from "../symbols/TheCryptSymbol";
import {TheCryptSoundManager} from "../sound/TheCryptSoundManager";

export class TheCryptBigWinPresentation implements SimplePresentation {
    private readonly FADE_AWAY_DURATION: number = 3;
    private _bigWinLevels: IBigWinLevel[];

    constructor() {
    }

    shouldRun(): boolean {
        return !TheCrypt.model.brokeTheBank && TheCrypt.model.isBigWin;
    }

    start(controller: SimplePresentationRunnerController): void {
        const levels: IBigWinLevel[] = this._bigWinLevels = TheCryptWinConfig.getBigWinLevels(TheCrypt.model.winRatio),
        maxLevel:number = levels.length;
        TheCrypt.bigWinView.maxLevel = maxLevel;

        const totalWin: number = TheCrypt.model.gameData.totalSpinWinnings,
            tl: gsap.core.Timeline = gsap.timeline(),
            startTime: number = TheCrypt.model.hasXWaysSymbolThisAvalanche ? 1 : 0,
        shakeDuration:number = 1.715;

        tl.add(TheCrypt.gameViewContainer.addDimmer(true, shakeDuration-0.5), startTime+0.7);
        for (let i: number = 0; i < 6; i++) {
            TheCrypt.realArea.allReels[i].reelView.getAllSymbols().forEach((sym: TheCryptSymbol) => {
                tl.add(sym.getShakeAnimation(shakeDuration), startTime);
            });
        }

        tl.add(()=>{TheCryptSoundManager.playBigWinLevelSound(0);}, startTime);

        tl.add(TheCrypt.bigWinView.show(0.1), startTime+shakeDuration-0.2);
        for (let index: number = 0; index < levels.length; index++) {
            const bigWinLevel: IBigWinLevel = levels[index],
                from: number = (index === 0)?0:bigWinLevel.from * TheCrypt.model.gameData.playedBetValue,
                to: number = ((index+1) === maxLevel)?totalWin:bigWinLevel.to * TheCrypt.model.gameData.playedBetValue,
                levelStartTime = tl.duration();
            tl.add(() => {
                controller.setSkipCallback(() => {
                    TheCrypt.bigWinView.onAbort(bigWinLevel.id-1);
                    tl.seek(bigWinLevel.type + "_end", false);
                });
            }, levelStartTime);
            tl.add([
                ()=>{
                    TheCryptSoundManager.playBigWinLevelSound(index);
                },
                TheCrypt.bigWinView.getLevelAnimation(from, to, bigWinLevel.duration, bigWinLevel.id)
            ], levelStartTime);
            tl.addLabel(bigWinLevel.type + "_end");
        }


        tl.add(() => {
            TheCrypt.bigWinView.hide(this.FADE_AWAY_DURATION);
        });
        tl.add(() => {
            controller.finish()
            //TheCrypt.keypadPlugin.setWin(TheCrypt.model.gameData.accumulatedRoundWin, true, TheCryptHelper.isWinBelowStake());
        }, `+=${this.FADE_AWAY_DURATION * 0.8}`);

    }
}
